export default __webpack_public_path__ + "images/f2bf3be9b02a16cb67e6c8e0f4bf970d-visa-icon.svg";